<template>
  <div class="layout-header">
    <header>
      <div>
        <a href="https://www.tokenpocket.pro/">
          <img src="../assets/images/logo.png" alt />
        </a>
      </div>
      <div>
        <span @click="languageChange">{{
          language === "en" ? "中" : "En"
        }}</span>
      </div>
    </header>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
export default {
  name: "LayoutHeader",
  computed: {
    ...mapGetters(["language"])
  },
  methods: {
    languageChange() {
      let lang = this.language === "zh" ? "en" : "zh";
      this.$store.commit("SET_LANGUAGE", lang);
      this.$i18n.locale = lang;
    }
  }
};
</script>

<style lang="scss" scoped>
.layout-header {
  position: absolute;
  width: 100%;
}
header {
  display: flex;
  align-items: center;
  padding: 0.5rem 0.32rem 0.5rem;
  div {
    flex: 1;
    &:first-child {
      img {
        height: 20px;
        float: left;
      }
    }
    &:last-child {
      text-align: right;
      span {
        display: inline-block;
        text-align: center;
        padding: 0.1rem 0;
        border-radius: 0.32rem;
        font-size: 0.26rem;
        font-weight: 400;
        cursor: pointer;
      }
    }
  }
}
</style>
